// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__tAawa","footerLabel":"Footer_footerLabel__ms7x2"};